import type { FetchError, NotifyApiErrorOptions, SnackbarMessage } from '~/types';

export const useApiErrorSnackbar = () => {
  const { add } = useSnackbar();

  const notifyApiError = (error: unknown, options: NotifyApiErrorOptions = {}) => {
    const errorReponse = error as FetchError;
    const title = options?.title || errorReponse?.message;
    const text = options?.text || errorReponse?.response?.data;
    const message = options?.message;
    const snackbarMessage: SnackbarMessage = {
      type: 'error',
      title,
      text,
      message
    };

    add(snackbarMessage);
  };

  return {
    notifyApiError
  };
};
